export default __webpack_public_path__ + "static/media/ratings.994e922d.png";